import React from 'react';
import Class10Fieldtrip2024 from 'views/Class10Fieldtrip2024';

const VissionAndMissionPage = () => {
  return <Class10Fieldtrip2024/>;
};

export default VissionAndMissionPage;